
export function env(value: any, defaultValue: any = null) {
    if (value == 'true') { return true; }
    if (value == 'false') { return false; }
    if (value == null) {
      return defaultValue;
    }
    return value;
}
